import { http, createConfig, fallback } from 'wagmi'
import { bsc, bscTestnet } from 'wagmi/chains'
import { injected, walletConnect } from 'wagmi/connectors'

const projectId = '0471566f19c8ba8ee6264da2774e823d'

// Use reliable RPC endpoints
const BSC_RPC = 'https://bsc-dataseed.binance.org/'

// Multiple BSC Testnet RPC endpoints for better reliability
const BSC_TESTNET_RPCS = [
  'https://data-seed-prebsc-1-s1.binance.org:8545/',
  'https://data-seed-prebsc-2-s1.binance.org:8545/',
  'https://data-seed-prebsc-1-s2.binance.org:8545/',
  'https://data-seed-prebsc-2-s2.binance.org:8545/',
  'https://bsc-testnet.public.blastapi.io',
  'https://bsc-testnet-rpc.publicnode.com'
]

export const config = createConfig({
  chains: [bsc],
  connectors: [injected(), walletConnect({ projectId }),], 
  ssr: true,
  transports: {
   [bsc.id]: http(BSC_RPC),
  //  [bscTestnet.id]: fallback(BSC_TESTNET_RPCS.map(rpc => http(rpc)))
  },
})